// Turbo restores focus across a stream render by id: it reads
// document.activeElement before the swap and, if an element with that id exists
// afterwards, focuses it. A tom-select control keeps its id across a re-render
// (it is derived from the field name), so a picker still focused when its own
// response lands gets refocused — and tom-select reads that as "open the
// dropdown", twice: once from openOnFocus, again when the focus-triggered
// remote load resolves a second later.
//
// Leaving focus on nothing is what stops Turbo finding anything to restore to.
//
// Scoped to pickers on purpose. Blurring unconditionally would also hit the
// toggles, native selects and number inputs that share these auto-submitting
// forms, where it costs a keyboard user their place mid-interaction.
//
// Do not pair with tom-select's createOnBlur: blurring with leftover text in
// the control would create an item from it.
export function blurFocusedPicker(): void {
  const active = document.activeElement;
  if (active instanceof HTMLElement && active.closest(".ts-wrapper")) {
    active.blur();
  }
}
